import React from "react";
import { Props } from "./type";

function GroupIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 18.083 12.658">
      <path
        d="M2.712,7.675A1.808,1.808,0,1,0,.9,5.867,1.81,1.81,0,0,0,2.712,7.675Zm12.658,0a1.808,1.808,0,1,0-1.808-1.808A1.81,1.81,0,0,0,15.371,7.675Zm.9.9H14.466a1.8,1.8,0,0,0-1.274.526A4.133,4.133,0,0,1,15.314,12.2h1.865a.9.9,0,0,0,.9-.9v-.9A1.81,1.81,0,0,0,16.275,8.579Zm-7.233,0A3.165,3.165,0,1,0,5.877,5.415,3.163,3.163,0,0,0,9.042,8.579Zm2.17.9h-.235a4.369,4.369,0,0,1-3.871,0H6.872a3.256,3.256,0,0,0-3.255,3.255v.814a1.357,1.357,0,0,0,1.356,1.356H13.11a1.357,1.357,0,0,0,1.356-1.356v-.814A3.256,3.256,0,0,0,11.211,9.483ZM4.891,9.1a1.8,1.8,0,0,0-1.274-.526H1.808A1.81,1.81,0,0,0,0,10.387v.9a.9.9,0,0,0,.9.9H2.766A4.143,4.143,0,0,1,4.891,9.1Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  );
}

export { GroupIcon };
